module.exports = __webpack_public_path__ + "static/media/klausura.85422de5.jpg";